<template>
  <div class="p-6">
    <div class="card">
      <div class="card-header">
        <h2 class="card-title">Jadwal Meeting Lingkar 9</h2>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <FullCalendar :options="calendarOptions" />
          </div>
        </div>
      </div>
    </div>
    <b-modal id="detail" title="Detail Jadwal Meeting">
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label for="">Partisipan</label>
            <p>{{ dataModal.participants  }}</p>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group>
            <label for="">Agenda</label>
            <p>{{ dataModal.title }}</p>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group>
            <label for="">Tanggal</label>
            <p>{{ dataModal.start | moment('dddd, DD MMMM YYYY HH:mm') }} {{ dataModal.end ? ' - ' + (dataModal.end | moment('HH:mm')) : '' }}</p>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group>
            <label for="">Catatan</label>
            <p>{{ dataModal.note }}</p>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import GlobalVue from '@/libs/Global'
import axios from "axios"
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"

import Gen from '@/libs/Gen.js'

export default {
  extends:GlobalVue,
  components: { FullCalendar },
  data() {
    return {
      dataModal: {},
      form: { title: "", participants: "", date: "", time: "", notes: "" },
      meetings: [],
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "timeGridWeek", // default tampilan bulan
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay"
        },
        slotLabelFormat: {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false // 👉 format 24 jam
        },
        eventTimeFormat: {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false // 👉 format 24 jam
        },
        events: [],
        eventClick: info => {
          this.dataModal = {
            title: info.event.extendedProps.title,
            start: info.event.start,
            end: info.event.end,
            participants: info.event.extendedProps.participants,
            note: info.event.extendedProps.note,
          }
          this.$bvModal.show('detail')
        }
      }
    }
  },
  methods: {
    async fetchMeetings() {
      Gen.apiRest("/meets", {public: true})
      .then(res => {
        console.log(res)
        const events = []

        res.data.data.forEach(v => {
          const event = {
            title: v.participants.join(', ') + ': ' + v.title,
            start: v.date + ' ' + v.start_time,
            extendedProps: {
              title: v.title,
              participants: v.participants.join(', '),
              note: v.note
            }
          }

          if (v.end_time) {
            event.end = v.date + ' ' + v.end_time
          }

          events.push(event)
        })

        this.calendarOptions.events = events
      })
    },
    async addMeeting() {
      await axios.post("http://localhost:8000/api/meetings", this.form)
      this.form = { title: "", participants: "", date: "", time: "", notes: "" }
      this.fetchMeetings()
    }
  },
  mounted() {
    this.fetchMeetings()
  }
}
</script>
